/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RenewTemporaryGrantForm = {
  /**
   * The new deadline. At least five minutes and at most 24 hours from now.
   */
  expiresAt: Date;
  /**
   * The temporary grant to renew.
   */
  id: string;
};

/** @internal */
export type RenewTemporaryGrantForm$Outbound = {
  expires_at: string;
  id: string;
};

/** @internal */
export const RenewTemporaryGrantForm$outboundSchema: z.ZodMiniType<
  RenewTemporaryGrantForm$Outbound,
  RenewTemporaryGrantForm
> = z.pipe(
  z.object({
    expiresAt: z.pipe(z.date(), z.transform(v => v.toISOString())),
    id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      expiresAt: "expires_at",
    });
  }),
);

export function renewTemporaryGrantFormToJSON(
  renewTemporaryGrantForm: RenewTemporaryGrantForm,
): string {
  return JSON.stringify(
    RenewTemporaryGrantForm$outboundSchema.parse(renewTemporaryGrantForm),
  );
}
